export enum IconPosition {
    Left = "Left",
    Right = "Right",
}